// src/components/SignIn.vue
<template>
  <div>
    <div v-if="!requireNewPassword">
      <h2>Sign In</h2>
      <div class='formcontainer'>
        <b-form-input v-model='form.username' type='text' class='input' placeholder="username"/>
        <b-form-input type='password' v-model='form.password' class='input' placeholder="password"/>
        <button v-on:click='signIn' class='button'>
          <span v-if="signingIn" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Sign In
        </button>
        <div v-if="authError">
          Incorrect username or password
        </div>
      </div>
    </div>
    <div v-if="requireNewPassword">
      <h2>You must change your password</h2>
      <div class='formcontainer'>
        <b-form-input type='password' v-model='form.password' class='input' placeholder="new password" :state='validNewPassword' />
        <b-form-input type='password' v-model='form.confirmPassword' class='input' placeholder="confirm new password" :state='validNewPassword' />
        <button v-on:click='changePassword' class='button'>
          <span v-if="changingPassword" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Change password
        </button>
      </div>
    </div>
    <p v-on:click="forgotPassword" class="toggle">Forgot Password?</p>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'
export default {
  name: 'home',
  props: ['forgotPassword'],
  data() {
    return {
      authError: false,
      changingPassword: false,
      form: {
        username: '',
        password: '',
        confirmPassword: '',
      },
      requireNewPassword: false,
      signingIn: false,
      user: null,
    }
  },
  methods: {
    async signIn() {
      this.signingIn = true
      const { username, password } = this.form
      try {
        this.authError = false
        let user = await Auth.signIn(username, password)
        if (user.challengeName == 'NEW_PASSWORD_REQUIRED') {
          this.user = user
          this.requireNewPassword = true
          this.form.password=''
        } else {
          AmplifyEventBus.$emit('authState', 'signedIn')
        }
        this.authError = false
      } catch(err) {
        console.log("Error signing in", err)
        this.authError = true
      }
      this.signingIn = false
    },
    async changePassword() {
      if (!this.validNewPassword)
        return

      this.changingPassword = true
      const { password } = this.form
      try {
        this.authError = false
        await Auth.completeNewPassword(this.user, password)
        AmplifyEventBus.$emit('authState', 'signedIn')
        this.authError = false
        this.user = null
      } catch(err) {
        console.log("Error completing new password", err)
        this.authError = true
      }
      this.changingPassword = false
    }
  },
  computed: {
    validNewPassword() {
      if(this.form.password == '') 
        return null
      return this.form.password == this.form.confirmPassword
    }
  }
}
</script>

<style>
.formcontainer {
  display: flex;
  flex-direction: column;
  width: 500px;
  margin: 0 auto;
}
.input {
  margin-bottom: 7px;
  height: 38px;
  border: none;
  outline: none;
  border-bottom: 2px solid #ddd;
  font-size: 20px;
}
.button {
  height: 45px;
  border: none;
  outline: none;
  background-color: #dddddd;
  margin-top: 8px;
  cursor: pointer;
  font-size: 18px;
}
.button:hover {
  opacity: .7
}
</style>